/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { Link } from 'ember-link';

export interface LinkWrapperSignature {
  Args: {
    isDisabled?: boolean;
    link?: Link;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLAnchorElement | HTMLDivElement;
}
const LinkWrapperComponent = templateOnlyComponent<LinkWrapperSignature>();
export default LinkWrapperComponent;
